module.exports = __webpack_public_path__ + "static/media/cat2.79329227.png";